import { render, staticRenderFns } from "./el-dialog.vue?vue&type=template&id=59e244e8&scoped=true"
import script from "./el-dialog.vue?vue&type=script&lang=js"
export * from "./el-dialog.vue?vue&type=script&lang=js"
import style0 from "./el-dialog.vue?vue&type=style&index=0&id=59e244e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e244e8",
  null
  
)

export default component.exports